import styled from 'styled-components';
import {device} from 'styled/device';

export const StyledDatesAndGuests = styled.div`
  display: flex;
  justify-content: center;
  width: 100%;
  background-color: #f4f5f6;
  border-radius: 20px;
  font-size: 16px;
  color: #23262f;
  padding: 15px 22px 15px 20px;

  .halfOfDateAndGuests {
    display: flex;
    grid-column-gap: 12px;

    &:first-child {
      position: relative;
      padding-right: 15px;
      margin-right: 25px;

      &:after {
        content: '';
        position: absolute;
        right: 0;
        width: 1px;
        background: #b1b5c4;
        height: 100%;
      }
    }
  }

  .iconCol {
    align-self: flex-start;
  }

  .title {
    color: #777e90;
    font-weight: 400;
    font-size: 14px;
    letter-spacing: -0.32px;
  }

  .value {
    color: #23262f;
    font-weight: 600;
    font-size: 16px;
    letter-spacing: -0.32px;
    white-space: nowrap;
    padding-right: 25px;
  }

  @media (max-width: ${device.mobileXL}) {
    padding: 15px 10px;
    width: 100%;

    & .halfOfDateAndGuests {
      padding: 0;
    }
  }

  @media (max-width: ${device.mobileM}) {
    & .halfOfDateAndGuests:first-child {
      padding: 0;
      margin: 0;

      &:after {
        display: none;
      }
    }
  }
`;

export const Col = styled.div`
  display: flex;
  flex-direction: column;
`;
